<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
			<v-card class="mb-2 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Layout di Stampa</p>
                    <v-spacer></v-spacer>
                </v-card-title>
				<v-divider></v-divider>
				<v-container class="pa-0" fluid>

					<v-row class="pa-4 pt-0">
						<v-col class="px-4 pt-0" cols="6">
    						<v-switch v-model="settings['attachments_products']" inset label="Inserisci allegati prodotti in stampa DDT" color="primary"></v-switch>
						</v-col>
					</v-row>
					<v-row class="pa-4 pt-0">
						<v-col class="px-4 pt-0 pb-0" cols="6">
    						<v-switch v-model="settings['print_txt']" inset label="Abilita stampa TXT" color="primary"></v-switch>
						</v-col>
					</v-row>
					<v-row class="pa-4 pt-0" v-if="settings['print_txt']">
						<v-col class="px-4 pt-0" cols="6">
							<v-autocomplete
								v-model="settings['txt_layout']"
								:items="txtDdtLayouts"
								label="Layout TXT"
								dense
								small-chips
								clearable
								outlined
								hide-details
							></v-autocomplete>
						</v-col>
					</v-row>					
				</v-container>


				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text class="pa-2 mx-2" color="primary" @click.native="saveSettings">Salva</v-btn>
				</v-card-actions>
			</v-card>
			<print-setting :model="this.model" class="pt-3"></print-setting>
		</v-col>
	</v-row>
</template>

<script>
	import PrintSetting from '@/components/common/PrintSetting'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin'

	export default {
		name:'ddts-print',
        components: {
			PrintSetting
        },
		mixins: [SettingsOptionsMixin],
		data() {
			return {
				model: 'ddt',
				settings: {
				    'txt_layout': null,
				    'print_txt': false,
				    'attachments_products': false,
                },
                txtDdtLayouts: [],
			}
		},

		methods: {
		    saveSettings() {
				let data = {model: 'ddt'}
				
		        _.forEach(this.settings, (value, key) => {
		            data[key] = value
				})
				
		        this.axios.post('settings/', data).then(response => {
					this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impostazioni salvate', value: true, color: 'success'})
					this.$store.commit('SET_SETTINGS', response.data.settings)
				}, response => {
					// error callback
				})
		    }
		},

		created() {
		    this.axios.post('layouts/', {'model': 'ddt'}).then(response => {

               	this.txtDdtLayouts = response.data.layouts.filter(layout => layout.type === 'txt')

            	this.axios.get('settings/ddt').then(response => {
					
					response.data.settings.filter((setting) => {
						return ['txt_layout', 'layout', 'attachments_products', 'print_txt'].includes(setting.key)
					}).map((setting) => {
						this.$set(this.settings, setting.key, setting.value)
					})
                }, response => {
                    // error callback
                })

            }, response => {
		        // error callback
			})

		}
	}
</script>

<style>

</style>
